<template>
  <div class="payment-receipt-1">
    <div class="col-12 text-center my-3" v-if="Object.keys(order).length > 0">
      <img class="img-fluid" :src="paymentReceiptPhoto" :alt="findAttributeOnSiteInfo('name')[0]"/>
    </div>
  </div>
</template>

<script>
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "PaymentReceipt1",
  props: {
    order: {}
  },
  computed: {
    paymentReceiptPhoto() {
      let metaValue = this.order.meta.filter(item => item.name == 'order_payment_receipt').map(item => item.value)
      if (metaValue.length > 0) {
        return `${findAttributeOnSiteInfo('host')[0]}/${metaValue[0]}`
      }
      return false
    }
  }
}
</script>


<style scoped>

</style>